import BaseFilter from '../modules/filters/baseFilter';
import mobileCarousel from '../utils/mobileCarousel';

mobileCarousel(
    'csr-actions__slider',
    'swiper-pagination-csr-actions',
    1.4,
    16,
    false
);

class CsrSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.sliders = this.root.querySelectorAll('[data-csr-actions-slider]');
        this.tabsEl = this.root.querySelector('[data-filter-switcher]');

        this.tabs = null;
        this.activeTabIndex = 0;

        return true;
    }

    init() {
        this.setTabs();
    }

    setTabs() {
        if (!this.tabsEl) return;
        this.tabs = new BaseFilter(this.tabsEl, this.root);
        this.root.addEventListener('filter-switcher-change', event =>
            this.switchTabs(event)
        );
        this.tabs.toggleClick(0);
    }

    switchTabs(event) {
        const { detail } = event;
        const { value } = detail;

        if (this.activeTabIndex === parseInt(value)) return;

        this.activeTabIndex = parseInt(value);
        this.resetTabs();
        this.setActiveTab(this.activeTabIndex);
    }

    resetTabs() {
        if (!this.sliders) return;
        this.sliders.forEach(item => item.classList.remove('active'));
    }

    setActiveTab(value) {
        const el = this.root.querySelector(
            `[data-csr-actions-slider="${value}"]`
        );
        console.log(value, el);

        if (!el) return;

        el.classList.add('active');
    }
}

const sections = document.querySelectorAll('[data-csr-actions]');
const initCsr = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new CsrSection(el);
    });
};

initCsr(sections);
